var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26525",
    "data-name": "Group 26525",
    transform: "translate(-76.5 -439.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37724",
    "data-name": "Path 37724",
    d: "M10.375,2.375a8,8,0,0,1,5.657,13.657A8,8,0,0,1,4.718,4.718,7.948,7.948,0,0,1,10.375,2.375Z",
    transform: "translate(74.625 437.625)",
    fill: "none",
    stroke: "#13cc93",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37723",
    "data-name": "Path 37723",
    d: "M-361.385,516.281l2.021,2,4.82-4.857",
    transform: "translate(442.885 -67.929)",
    fill: "none",
    stroke: "#13cc93",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.7439a12503146bdae11790db1bbbf251.svg";
export { ForwardRef as ReactComponent };